import React, {memo, useEffect, useMemo, useState} from 'react';
import T from 'prop-types';
import {useFormikContext} from 'formik';
import {nanoid} from 'nanoid';
import {RadioGroup} from '@material-ui/core';
import {
  DashboardField,
  DashboardFields,
  DashboardHolder,
  DashboardTitle
} from 'routes/App/dashboard/styles';
import DaysPicker from 'routes/App/settings/DeliveryHoursPicker/DaysPicker';
import {ButtonOutline} from 'components/buttons';
import {
  useDeliveryHoursContext,
  useDeliveryHoursContextUpdate
} from 'routes/App/settings/DeliveryHoursPicker/context/DaysPickerContext';
import {
  generateTimeRanges,
  openingDaysServerParser
} from 'routes/App/settings/helpers';
import {isValueChanged} from 'helpers/functionUtils/dayAndTimePickerUtils';

const DeliveryDaysPickerContainer = ({DeliveryDays}) => {
  const deliveryDays = useDeliveryHoursContext();
  const setDeliveryDays = useDeliveryHoursContextUpdate();
  const {
    setFieldValue,
    values: {DeliveryHoursChanged}
  } = useFormikContext();
  const [openingDaysRadio, setOpeningDaysRadio] = useState(true);
  const isDayError = useMemo(
    () => !openingDaysServerParser(deliveryDays).length,
    [deliveryDays]
  );

  useEffect(() => {
    if (DeliveryDays.length) {
      setDeliveryDays(DeliveryDays);
    } else {
      setDeliveryDays([
        {
          id: nanoid(),
          days: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
          startOfWorkingDay: '',
          endOfWorkingDay: '',
          duration: '',
          timePeriods: [
            {
              id: nanoid(),
              startOfWorkingDay: '10:00 AM',
              endOfWorkingDay: '10:00 PM',
              duration: '12:00',
              hoursIntervals: [
                Object.keys(generateTimeRanges(15, 'en', 10, 22))
              ]
            }
          ]
        }
      ]);
    }
  }, [DeliveryDays]);

  useEffect(() => {
    const checkOpeningDaysRadio = () => {
      if (deliveryDays.length === 1) {
        return (
          deliveryDays[0].days.length === 7 &&
          deliveryDays[0].timePeriods[0]?.startOfWorkingDay === '12:00 AM' &&
          deliveryDays[0].timePeriods[0]?.endOfWorkingDay === '12:00 AM'
        );
      }
      return false;
    };

    setOpeningDaysRadio(checkOpeningDaysRadio());
  }, [deliveryDays]);

  const createOpeningDay = () => {
    const newId = nanoid();
    setDeliveryDays((prevState) => [
      ...prevState,
      {
        id: newId,
        days: [],
        startOfWorkingDay: '',
        endOfWorkingDay: '',
        duration: '',
        timePeriods: [
          {
            id: nanoid(),
            startOfWorkingDay: '10:00 AM',
            endOfWorkingDay: '10:00 PM',
            duration: '12:00',
            hoursIntervals: [Object.keys(generateTimeRanges(15, 'en', 10, 22))]
          }
        ]
      }
    ]);

    setFieldValue(
      'DeliveryHoursChanged',
      isValueChanged(DeliveryHoursChanged, newId)
    );
  };

  return (
    <>
      <DashboardHolder>
        {/* <DashboardTitle className='WithLine mBottom titleMd'>
          Opening Days and Hours
        </DashboardTitle> */}
        <div style={{color: 'red', height: '1em'}}>
          {isDayError && 'Please, select time of work'}
        </div>
        <RadioGroup
          aria-label='Delivery Hours'
          name='openingDaysRadio'
          onChange={(e) => setOpeningDaysRadio(e.target.checked)}
          value={openingDaysRadio}
        >
          <DashboardFields>
            <DashboardField className='w100 flexColumn'>
              <DaysPicker />
            </DashboardField>
          </DashboardFields>
        </RadioGroup>
      </DashboardHolder>
      {/* {openingDaysRadio === 'certainDays' && ( */}
      <DashboardHolder>
        <DashboardFields>
          <DashboardField className='w100 justifyCenter'>
            {deliveryDays.reduce((acc, elem) => acc + elem.days.length, 0) <
              7 && (
              <ButtonOutline
                className='DashboardFieldButton'
                type='button'
                onClick={() => createOpeningDay()}
              >
                + Add Another Time
              </ButtonOutline>
            )}
          </DashboardField>
        </DashboardFields>
      </DashboardHolder>
      {/* )} */}
    </>
  );
};

DeliveryDaysPickerContainer.propTypes = {
  DeliveryDays: T.array.isRequired
};
export default DeliveryDaysPickerContainer;
